import common from '@/store/common/mutations';
import * as types from './mutation-types';

const getInit = () => {
	return {
		searchParams: {
			partNm: '',
			bomType: '10' //정전개 10 , 역전개 20
		},
		bomInfo: [],
		pagingInfo: {
			currentPage: 1,
			pageUnit: 30,
			totalSize: 0
		}
	};
};

export default {
	...common,
	[types.STATE_INIT]: state => {
		Object.assign(state, getInit()); //
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	}
};
